import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CustomValidators } from 'ng2-validation';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from '../settings/settings.service';


@Component({
    selector: 'app-log-in',
    templateUrl: './log-in.component.html',
    styleUrls: ['./log-in.component.less'],
    standalone: false
})
export class LogInComponent implements OnInit {

  valForm: FormGroup;
  codeForm: FormGroup;
  step: 'email' | 'code' = 'email';

  constructor(fb: FormBuilder, private http: HttpClient, private router: Router, public snackBar: MatSnackBar, public settings: SettingsService) {

    this.valForm = fb.group({
      'email': ['', Validators.compose([Validators.required, CustomValidators.email])],
      'platform': ['web']
    });

    this.codeForm = fb.group({
      'code': ['', Validators.compose([Validators.required, Validators.pattern(/^[0-9]{6}$/)])]
    });

   }

   randomImage: string = '';
   private images: string[] = [
     '../../assets/images/33.jpg',
     '../../assets/images/3.jpg',
     '../../assets/images/4.jpg',
     '../../assets/images/7.jpg',
     '../../assets/images/9.jpg',
     '../../assets/images/12.jpg',
     '../../assets/images/14.jpg',
     '../../assets/images/17.jpg',
     '../../assets/images/23.jpg',
     '../../assets/images/2.jpg',
     '../../assets/images/15.jpg',
     '../../assets/images/26.jpg',
    ];

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.images.length);
    this.randomImage = this.images[randomIndex];
  }


  ngOnInit(): void {

    this.setRandomBackground();

    let token = localStorage.getItem('token');

    if(token != null){

      setTimeout(()=>{
        this.router.navigate(['home']);
      }, 1500);
    }

  }

  disabled: boolean = false;
  resendCooldown: number = 0;
  private resendTimer: any;

  requestCode($ev: any) {
    $ev.preventDefault();

    this.valForm.controls['email'].markAsTouched();

    if (!this.valForm.valid) {
      return;
    }

    this.disabled = true;

    var endpoint = SettingsService.API_ENDPOINT + 'login/request-code/';

    this.http.post<any>(endpoint, this.valForm.value).subscribe(
      () => {
        this.disabled = false;
        this.step = 'code';
        this.startResendCooldown();
      },
      (error) => {
        this.disabled = false;
        const message = error?.error?.error?.[0]?.message || 'No fue posible enviar el código.';
        this.valForm.controls['email'].setErrors({ orgNotAllowed: message });
      }
    );
  }

  verifyCode($ev: any) {
    $ev.preventDefault();

    this.codeForm.controls['code'].markAsTouched();

    if (!this.codeForm.valid) {
      return;
    }

    this.disabled = true;

    var endpoint = SettingsService.API_ENDPOINT + 'login/verify-code/';
    var value = { email: this.valForm.value.email, code: this.codeForm.value.code };

    this.http.post<any>(endpoint, value).subscribe(
      (data) => {

        localStorage.setItem("token", data.token);
        let role_code = data.user.roles[0].code;
        localStorage.setItem("role", role_code);
        localStorage.setItem("email", data.user.email);

        localStorage.setItem('user_logged', data.user.email);
        if (localStorage.getItem('theming') == null || localStorage.getItem('theming') == "" || localStorage.getItem('theming') == undefined) {
          localStorage.setItem('theming', 'rose-red');
        }

        this.disabled = false;
        this.router.navigate(['home']);
      },
      (error) => {
        this.disabled = false;
        const message = error?.error?.error?.[0]?.message || 'No fue posible validar el código.';
        this.codeForm.controls['code'].setErrors({ invalid: message });
      }
    );
  }

  resendCode() {
    if (this.resendCooldown > 0 || this.disabled) {
      return;
    }
    this.disabled = true;
    var endpoint = SettingsService.API_ENDPOINT + 'login/request-code/';

    this.http.post<any>(endpoint, this.valForm.value).subscribe(
      () => {
        this.disabled = false;
        this.codeForm.controls['code'].setValue('');
        this.startResendCooldown();
      },
      (error) => {
        this.disabled = false;
        const message = error?.error?.error?.[0]?.message || 'No fue posible reenviar el código.';
        this.snackBar.open(message, "Aceptar", { duration: 20000, panelClass: ['simpli-snack'] });
      }
    );
  }

  private startResendCooldown() {
    this.resendCooldown = 30;
    clearInterval(this.resendTimer);
    this.resendTimer = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) {
        clearInterval(this.resendTimer);
      }
    }, 1000);
  }

  backToEmail() {
    this.step = 'email';
    this.codeForm.reset();
    clearInterval(this.resendTimer);
    this.resendCooldown = 0;
  }

}
